import {Injectable} from '@angular/core'

export declare type  ThemeStrategy = 'light' | 'dark' | 'system'
const storageKey = 'themeStrategy'

@Injectable()
export class ThemeService {
  private readonly strategies: ThemeStrategy[] = ['light', 'dark', 'system']

  constructor() {
  }

  public init(): void {
    document.documentElement.classList.add(this.theme)
  }

  public get themeStrategy(): ThemeStrategy {
    const themeStrategy = localStorage.getItem(storageKey)

    if (!themeStrategy) return 'system'

    return themeStrategy as ThemeStrategy
  }

  public get theme(): 'light' | 'dark' {
    if (this.themeStrategy === 'system') return this.systemTheme

    return this.themeStrategy
  }

  public get systemTheme(): 'light' | 'dark' {
    const isDarkTheme = window.matchMedia('(prefers-color-scheme: dark)').matches
    return isDarkTheme ? 'dark' : 'light'
  }

  public toggleStrategy(): void {
    const currentStrategyIndex = this.strategies.indexOf(this.themeStrategy)

    const nextStrategyIndex = currentStrategyIndex + 1 >= this.strategies.length ? 0 : currentStrategyIndex + 1
    const nextStrategy = this.strategies[nextStrategyIndex]

    localStorage.setItem(storageKey, nextStrategy)

    if (this.theme === 'dark') {
      document.documentElement.classList.remove('light')
      document.documentElement.classList.add(this.theme)
    } else {
      document.documentElement.classList.remove('dark')
      document.documentElement.classList.add(this.theme)
    }
  }

}
